import Component from './AlgoliaPlaces';

export default Component;
